module.exports = __webpack_public_path__ + "img/s5_stepimg03.27549042.png";